import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
import { BREAKPOINTS } from "../../constants/design";
import React, { memo, useCallback } from 'react';
import PropTypes from 'prop-types';
import { useMedia } from 'react-use';
import { Carousel, useCarousel } from "../copenhagen-carousel";
import GridContainer from "../grid-container";
import { Headline, Section } from "./testimonials-section.styles";
import { TestimonialsContainer } from "./testimonial.styles";
import Testimonial, { testimonialPropTypes } from "./testimonial";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var USE_MEDIA_DEFAULT_STATE = false;
var TestimonialsSection = function TestimonialsSection(_ref) {
  var headline = _ref.headline,
    onClickTestimonial = _ref.onClickTestimonial,
    testimonials = _ref.testimonials;
  var carousel = useCarousel({
    totalPages: testimonials.length,
    isInfinite: true
  });
  var onClick = useCallback(function (index) {
    carousel.goToIndex(index);
    onClickTestimonial(index);
  }, [carousel, onClickTestimonial]);
  var html = {
    __html: headline
  };
  var isMobile = useMedia("(max-width: ".concat(BREAKPOINTS.md, "px)"), USE_MEDIA_DEFAULT_STATE);
  return /*#__PURE__*/_jsxs(Section, {
    "data-qa": "testimonials-section",
    children: [headline && /*#__PURE__*/_jsx(GridContainer, {
      children: /*#__PURE__*/_jsx(Headline, {
        dangerouslySetInnerHTML: html,
        size: 2
      })
    }), /*#__PURE__*/_jsx(TestimonialsContainer, {
      children: /*#__PURE__*/_jsx(Carousel, {
        gap: "8px",
        hook: carousel,
        touch: isMobile,
        children: testimonials.map(function (testimonial, index) {
          return /*#__PURE__*/_jsx(Testimonial, _objectSpread({
            index: index,
            onClick: onClick
          }, testimonial), "testimonial-".concat(index));
        })
      })
    })]
  });
};
TestimonialsSection.propTypes = {
  headline: PropTypes.string,
  onClickTestimonial: PropTypes.func,
  testimonials: PropTypes.arrayOf(testimonialPropTypes)
};
TestimonialsSection.defaultProps = {
  headline: null,
  onClickTestimonial: function onClickTestimonial() {
    return null;
  },
  testimonials: []
};
export default /*#__PURE__*/memo(TestimonialsSection);